/* import __COLOCATED_TEMPLATE__ from './classification-form.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import clsx from 'clsx';
import { CLASSIFICATION_CATEGORIES, CLASSIFICATION_SECTIONS } from 'sh-www/models/classification';

const CLASS_NAME = 'SH-c-admin-classification-form';

const mapOriginalClassifications = (classifications) => {
  const classificationItems = {
    [CLASSIFICATION_SECTIONS.SUBJECT]: [],
    [CLASSIFICATION_SECTIONS.MEDIUM]: [],
    [CLASSIFICATION_SECTIONS.INDUSTRY]: [],
  };

  classifications.forEach(classification => {
    switch(classification.category) {
      case CLASSIFICATION_CATEGORIES.CATEGORY_SUBJECT:
        classificationItems[CLASSIFICATION_SECTIONS.SUBJECT].push(classification);
        break;
      case CLASSIFICATION_CATEGORIES.CATEGORY_MEDIUM:
        classificationItems[CLASSIFICATION_SECTIONS.MEDIUM].push(classification);
        break;
      case CLASSIFICATION_CATEGORIES.CATEGORY_INDUSTRY:
        classificationItems[CLASSIFICATION_SECTIONS.INDUSTRY].push(classification);
        break;
    }
  });

  return classificationItems;
}

class ClassificationForm extends Component {
  @tracked selectedClassifications = mapOriginalClassifications(this.args.projectdigest.classifications);
  @tracked featured = this.args.projectdigest.featured;

  get className() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get subjectOptions() {
    return this.args.classificationItems[CLASSIFICATION_SECTIONS.SUBJECT];
  }

  get mediumOptions() {
    return this.args.classificationItems[CLASSIFICATION_SECTIONS.MEDIUM];
  }

  get industryOptions() {
    return this.args.classificationItems[CLASSIFICATION_SECTIONS.INDUSTRY];
  }

  get selectedSubjects() {
    return this.selectedClassifications[CLASSIFICATION_SECTIONS.SUBJECT];
  }

  get selectedMediums() {
    return this.selectedClassifications[CLASSIFICATION_SECTIONS.MEDIUM];
  }

  get selectedIndustries() {
    return this.selectedClassifications[CLASSIFICATION_SECTIONS.INDUSTRY];
  }

  @action
  onSubjectAdded(addedClassification) {
    this.onAdded(CLASSIFICATION_SECTIONS.SUBJECT, addedClassification);
  }

  @action
  onSubjectRemoved(removedClassification) {
    this.onRemoved(CLASSIFICATION_SECTIONS.SUBJECT, removedClassification);
  }

  @action
  onMediumAdded(addedClassification) {
    this.onAdded(CLASSIFICATION_SECTIONS.MEDIUM, addedClassification);
  }

  @action
  onMediumRemoved(removedClassification) {
    this.onRemoved(CLASSIFICATION_SECTIONS.MEDIUM, removedClassification);
  }

  @action
  onIndustryAdded(addedClassification) {
    this.onAdded(CLASSIFICATION_SECTIONS.INDUSTRY, addedClassification);
  }

  @action
  onIndustryRemoved(removedClassification) {
    this.onRemoved(CLASSIFICATION_SECTIONS.INDUSTRY, removedClassification);
  }

  @action
  onAdded(category, addedClassification) {
    const classificationIndex = this.selectedClassifications[category].findIndex(classification => classification.id == addedClassification.id);

    if (classificationIndex === -1) {
      this.selectedClassifications = {
        ...this.selectedClassifications,
        [category]: [addedClassification, ...this.selectedClassifications[category]]
      };
    }

    this.args.setClassificationsChanged(this.selectedClassifications, this.args.projectdigest.id);
  }

  @action
  onRemoved(category, removedClassification) {
    const newArray = this.selectedClassifications[category].filter(classification => {
      return classification.id != removedClassification.id;
    });

    this.selectedClassifications = { ...this.selectedClassifications, [category]: newArray };

    this.args.setClassificationsChanged(this.selectedClassifications, this.args.projectdigest.id);
  }

  @action
  onFeaturedClicked() {
    this.featured = !this.featured;
    this.args.setFeaturedChanged(this.featured, this.args.projectdigest.id);
  }
}

export default ClassificationForm;
